import moment from 'moment-timezone'

export const HO_CHI_MINH_TIMEZONE = 'Asia/Ho_Chi_Minh'
export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATE_TIME_FORMAT = 'DD/MM/YYYY H:mm'
export const TIME_FORMAT = 'HH:mm'
export const ISO_DATE_FORMAT = 'YYYY-MM-DD'

export const getHoChiMinhMoment = value => {
  return value ? moment.tz(value, HO_CHI_MINH_TIMEZONE) : moment.tz(HO_CHI_MINH_TIMEZONE)
}

export const parseHoChiMinhDate = (value, format = DATE_FORMAT) => {
  return moment.tz(value, format, HO_CHI_MINH_TIMEZONE)
}

export const formatHoChiMinhDate = (value, defaultToToday = false) => {
  if (!value && !defaultToToday) return ''
  return getHoChiMinhMoment(value).format(DATE_FORMAT)
}

export const formatHoChiMinhDateTime = value => {
  return value ? getHoChiMinhMoment(value).format(DATE_TIME_FORMAT) : ''
}

export const formatHoChiMinhTime = value => {
  return value ? getHoChiMinhMoment(value).format(TIME_FORMAT) : ''
}

export const buildHoChiMinhDateTimeISOString = (dateText, timeText) => {
  return moment.tz(`${dateText} ${timeText}`, `${DATE_FORMAT} ${TIME_FORMAT}`, HO_CHI_MINH_TIMEZONE).toISOString()
}

export const buildHoChiMinhDateBoundaryISOString = (dateText, boundary = 'start') => {
  const date = parseHoChiMinhDate(dateText)
  return date[boundary === 'start' ? 'startOf' : 'endOf']('day').toISOString()
}

export const parseHoChiMinhIsoDate = value => {
  return parseHoChiMinhDate(value, ISO_DATE_FORMAT)
}
